module.exports = __webpack_public_path__ + "img/logo22.7781c093.jpg";